import type { GenericTranslationsObject } from '@payloadcms/translations'

export const zhTw: GenericTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-seo': {
    almostThere: '快完成了',
    autoGenerate: '自動產生',
    bestPractices: '最佳做法',
    characterCount: '{{current}}/{{minLength}}-{{maxLength}} 字元，',
    charactersLeftOver: '多出 {{characters}} 個字元',
    charactersToGo: '還差 {{characters}} 個字元',
    charactersTooMany: '超出 {{characters}} 個字元',
    checksPassing: '{{current}} 項檢查通過，共 {{max}} 項',
    good: '良好',
    imageAutoGenerationTip: '系統會自動擷取選取的主圖。',
    lengthTipDescription:
      '長度應介於 {{minLength}} 到 {{maxLength}} 個字元。若需撰寫高品質後設資料描述的協助，請參閱',
    lengthTipTitle:
      '長度應介於 {{minLength}} 到 {{maxLength}} 個字元。若需撰寫高品質後設資料標題的協助，請參閱',
    missing: '尚未設定',
    noImage: '沒有圖片',
    preview: '預覽',
    previewDescription: '實際搜尋結果可能會因內容與關聯性而有所不同。',
    tooLong: '過長',
    tooShort: '過短',
  },
}
